module.exports = __webpack_public_path__ + "img/icon_5_84.ca4a14b9.png";